var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "section",
        [
          _c(
            "v-parallax",
            { attrs: { src: "/static/images/colleges.jpg", height: "800" } },
            [
              _c(
                "v-layout",
                {
                  staticClass: "white--text",
                  attrs: {
                    column: "",
                    "align-center": "",
                    "justify-center": ""
                  }
                },
                [
                  _c("v-layout", { attrs: { row: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            lg6: "",
                            sm4: "",
                            mt5: "",
                            ml5: "",
                            "align-center": ""
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "white--text display-4 font-weight-black font-italic text-xs-center mt-5"
                            },
                            [
                              _vm._v(
                                "Give Your Students the Edge in the Modern Art Climate."
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        [
                          _c(
                            "v-stepper",
                            {
                              staticClass: "mb-5 transparent2",
                              model: {
                                value: _vm.e1,
                                callback: function($$v) {
                                  _vm.e1 = $$v
                                },
                                expression: "e1"
                              }
                            },
                            [
                              _c(
                                "v-stepper-header",
                                [
                                  _c("v-stepper-step", {
                                    attrs: {
                                      dark: "",
                                      complete: _vm.e1 > 1,
                                      step: "1"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c("v-stepper-step", {
                                    attrs: {
                                      dark: "",
                                      complete: _vm.e1 > 2,
                                      step: "2"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _c("v-stepper-step", {
                                    attrs: { dark: "", step: "3" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-stepper-items",
                                [
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "1" } },
                                    [
                                      _c(
                                        "form",
                                        { staticClass: " white--text" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              dark: "",
                                              "error-messages": _vm.nameErrors,
                                              counter: 20,
                                              label: "Name",
                                              required: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.name.$touch()
                                              },
                                              blur: function($event) {
                                                _vm.$v.name.$touch()
                                              }
                                            },
                                            model: {
                                              value: _vm.name,
                                              callback: function($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              dark: "",
                                              "error-messages": _vm.emailErrors,
                                              label: "E-mail",
                                              required: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.email.$touch()
                                              },
                                              blur: function($event) {
                                                _vm.$v.email.$touch()
                                              }
                                            },
                                            model: {
                                              value: _vm.email,
                                              callback: function($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              dark: "",
                                              label: "phone",
                                              value: "XXX-XXX-XXXX",
                                              "prepend-icon": "phone",
                                              "single-line": ""
                                            },
                                            model: {
                                              value: _vm.phone,
                                              callback: function($$v) {
                                                _vm.phone = $$v
                                              },
                                              expression: "phone"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.e1 = 2
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n          Continue\n        "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "2" } },
                                    [
                                      _c(
                                        "form",
                                        { staticClass: "form white--text" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              dark: "",
                                              "error-messages": _vm.nameErrors,
                                              counter: 20,
                                              label: "College Association: ",
                                              required: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.name.$touch()
                                              },
                                              blur: function($event) {
                                                _vm.$v.name.$touch()
                                              }
                                            },
                                            model: {
                                              value: _vm.collegeAssociation,
                                              callback: function($$v) {
                                                _vm.collegeAssociation = $$v
                                              },
                                              expression: "collegeAssociation"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            attrs: {
                                              dark: "",
                                              "error-messages": _vm.emailErrors,
                                              label:
                                                "How Many Art Students Are In Your Program:",
                                              required: ""
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.$v.email.$touch()
                                              },
                                              blur: function($event) {
                                                _vm.$v.email.$touch()
                                              }
                                            },
                                            model: {
                                              value: _vm.numberOfStudents,
                                              callback: function($$v) {
                                                _vm.numberOfStudents = $$v
                                              },
                                              expression: "numberOfStudents"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: { click: _vm.submit }
                                        },
                                        [_vm._v("Submit\n        ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.e1 = 1
                                            }
                                          }
                                        },
                                        [_vm._v("BAck")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-stepper-content",
                                    { attrs: { step: "3" } },
                                    [
                                      _c("v-flex", { attrs: { lg12: "" } }, [
                                        _vm._v(
                                          "\n            Thank You! We will be reaching out to you shortly. \n        "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.e1 = 1
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n          Submit Again\n        "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c(
            "v-layout",
            { staticClass: "my-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { lg6: "", sm4: "", mt5: "", "align-right": "" } },
                [
                  _c("img", {
                    staticClass: "ml-5 text-xs-right",
                    attrs: { src: "/static/images/img1.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { lg6: "", sm4: "", mt5: "" } }, [
                _c(
                  "div",
                  { staticClass: "panels" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "display-3 font-weight-black font-italic text-xs-left mt-5 mr-5\n            "
                      },
                      [
                        _vm._v(
                          "Most Colleges’ Art Departments Do Not Stress Marketing Your Art.\n              "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "display-2 font-weight-black font-italic text-xs-left mt-3"
                      },
                      [_vm._v(" We’ll Take Care of That For You. ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "title2 text-xs-left mt-3 mr-5" },
                      [
                        _vm._v(
                          " Many art programs at colleges and universities turn aspiring artists into talented and skilled painters, drawers, photographers, etc… But a lot of those schools brush only briefly over the elements of marketing that go into being an artist. "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-3 mt-3",
                        attrs: { slot: "activator", icon: "" },
                        on: { click: _vm.info },
                        slot: "activator"
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "ml-5 orange--text text--lighten-1",
                            attrs: { "x-large": "" }
                          },
                          [_vm._v("fas fa-angle-double-right")]
                        ),
                        _vm._v("\n              Learn more")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "my-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    lg12: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "display-3 font-weight-black font-italic text-xs-center mt-5"
                    },
                    [
                      _vm._v(
                        "Here’s How it Works:               \n              "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("v-container", [
                    _c(
                      "div",
                      { staticClass: "title2 text-xs-center ml-5 mr-5 mt-5" },
                      [
                        _c("h3", [
                          _vm._v("1. Create a profile for your students, "),
                          _c("br"),
                          _vm._v("Art Department or Class")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "title2 font-italic text-xs-left mt-3 ml-5"
                      },
                      [
                        _c("span", { staticClass: "font-weight-thin" }, [
                          _vm._v(
                            "Use a master e-mail so you can overlook all of the accounts in your organization. Set up Your Organization account settings to determine how you will be notified and how frequently you will be notified of student activity. Many schools have used the site as a way for students to submit their projects!\n "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("img", {
                    staticClass: " mt-5 ml-5 mb-5 elevation-2",
                    attrs: { src: "/static/images/home.png", width: "100%" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("v-container", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "headline font-weight-black font-italic text-xs-center ml-5 mr-5 mt-5"
                      },
                      [
                        _c("h3", [
                          _vm._v(
                            "2. Have your students create accounts and request to join your organization!"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "title2 font-italic text-xs-left mt-3 ml-5"
                      },
                      [
                        _vm._v(
                          " Use a master e-mail so you can overlook all of the accounts in your organization. Set up Your Organization account settings to determine how you will be notified and how frequently you will be notified of student activity. Many schools have used the site as a way for students to submit their projects!\n "
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("img", {
                    staticClass: " mt-5 ml-5 mb-5 elevation-2",
                    attrs: { src: "/static/images/blogs.png", width: "100%" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", "mb-5": "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("v-container", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "title2 font-italic text-xs-center ml-5 mr-5 mt-5"
                      },
                      [
                        _c("h3", [
                          _vm._v(
                            "3. All Students who join your organization will be granted 5-20 credits"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "title2 text-xs-left mt-3 ml-5" },
                      [
                        _vm._v(
                          " per quarter depending on your Organization Package. Students Use their Credits to Submit their art to some of the biggest online art-sharing pages, magazines and publications on the internet! \n\n "
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    lg5: "",
                    sm12: "",
                    mt5: "",
                    ml5: "",
                    "align-center": ""
                  }
                },
                [
                  _c("img", {
                    staticClass: " mt-5 ml-5 elevation-2",
                    attrs: { src: "/static/images/popular.png", width: "100%" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "section",
            [
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "my-5", attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        lg12: "",
                        sm12: "",
                        mt5: "",
                        ml5: "",
                        "align-center": ""
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "display-3 font-weight-black font-italic text-xs-center mt-5"
                        },
                        [
                          _vm._v(
                            "Meet The Founders             \n              "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        lg5: "",
                        sm12: "",
                        mt5: "",
                        ml5: "",
                        "text-xs-right": ""
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ml-5 elevation-0",
                        attrs: { src: "/static/images/nick.jpg", width: "60%" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg9: "" } }, [
                    _c("div", { staticClass: " title2 ml-5 mr-5 mt-5" }, [
                      _c("h2", [_vm._v("Nick McElmurry")]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-weight-thin" }, [
                        _c("em", [_vm._v("Founder and Owner")]),
                        _c("br")
                      ]),
                      _vm._v(
                        "-Marketing Executive with State Farm, Jamba Juice, Sunpower, and numerous small companies"
                      ),
                      _c("br"),
                      _vm._v("\n-Certified Copy Writer, 2018 "),
                      _c("br"),
                      _vm._v(
                        "\n-Certified Insurance Agent, Property & Casualty, 2018"
                      ),
                      _c("br"),
                      _vm._v("\n-Certified Real Estate Agent, 2014 "),
                      _c("br"),
                      _vm._v(
                        "\n-2 BA from UCSC, Business Management Economics & Philosophy "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n-Musician and Band Manager for Water Color Weekend, Leisure Suit, and other local bands."
                      ),
                      _c("br"),
                      _vm._v(
                        "\n-Published Philosopher in the American Journal of Philosophy"
                      ),
                      _c("br"),
                      _vm._v("\n-CUPSI National Slam Poetry Semi-Finalist"),
                      _c("br")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { attrs: { row: "", "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        lg5: "",
                        sm12: "",
                        mt5: "",
                        ml5: "",
                        "text-xs-right": ""
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "ml-5 mt-5 elevation-0",
                        attrs: { src: "/static/images/bw.jpg", width: "60%" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { lg9: "" } }, [
                    _c("div", { staticClass: " title2 ml-5 mr-5" }, [
                      _c("h2", [_vm._v("Scott Davis")]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "font-weight-thin" }, [
                        _c("em", [_vm._v("CTO and Lead Website Designer")]),
                        _c("br")
                      ]),
                      _vm._v(
                        "Scott handles much of our development work and other stuff. As our Chief Creative/Developer, he's responsible for the overall work product of the company, overseeing our Design & Development. In the rare event that he's not working, he spends as much time as possible with his wife and his daughter. While he does occasionally get some sleep, it's usually when he passes out in his chair while working through the middle of the night.\n"
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                "hide-overlay": "",
                transition: "dialog-bottom-transition"
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "dialogCard" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-toolbar-title"),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "white--text display-3 font-weight-black font-italic text-xs-center mt-5"
                    },
                    [
                      _c("b", [
                        _vm._v(
                          "Most Colleges’ Art Departments Do Not Stress Marketing Your Art. "
                        ),
                        _c("br"),
                        _vm._v("We’ll Take Care of That For You.")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "white--text display-2 font-weight-black font-italic text-xs-center mt-5"
                    },
                    [
                      _vm._v(
                        "Many art programs at colleges and universities turn aspiring artists into talented and skilled painters, drawers, photographers, etc… "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "white--text display-2 font-weight-black font-italic text-xs-center mt-5"
                    },
                    [
                      _vm._v(
                        "But a lot of those schools brush only briefly over the elements of marketing that go into being an artist. Our innovative platform gives professors an easy way to review and grade their student’s work while also giving the student the tools to show their art to the world! Being a successful artist deals entirely with reach, prestige and technique.  "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "white--text display-2 font-weight-black font-italic text-xs-center mt-5"
                    },
                    [
                      _vm._v(
                        "Though ShareYourselfArtists.com cannot teach the technique behind being an incredible artist, it is the BEST tool for an artist to build reach and credibility. We connect artists to a network of the largest art sharing blogs, social media pages, and magazines on the web. This new and quickly growing website allows your students to submit to publications with MILLIONS OF FOLLOWERS… all in just the click of a button.  "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "mb-5", attrs: { row: "", "align-center": "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                lg5: "",
                sm12: "",
                mt5: "",
                ml5: "",
                "text-xs-right": ""
              }
            },
            [
              _c("img", {
                staticClass: "ml-5 mt-5 elevation-0",
                attrs: { src: "/static/images/testimonial.jpg", width: "60%" }
              })
            ]
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { lg9: "" } }, [
            _c("div", { staticClass: " title2 ml-5 mr-5" }, [
              _c("h2", [_vm._v("An Experience Created Directly For You ")]),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "font-weight-thin" }, [
                _vm._v("\n        We have tested "),
                _c("b", [_vm._v("ShareYourselfArtists.com")]),
                _vm._v(
                  " with 3 different colleges in the Bay Area and have had incredible results. But, the best part about our site is that we will Build Your Organization’s account to your exact liking. It is our guarantee. \n\n We have a team of dedicated coders and website designers who will Ensure you get everything you could ask for and more through our site."
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-flex",
            { attrs: { m5: "" } },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "mb-5 ml-5 mr-5 ",
                  model: {
                    value: _vm.e1,
                    callback: function($$v) {
                      _vm.e1 = $$v
                    },
                    expression: "e1"
                  }
                },
                [
                  _c(
                    "v-stepper-header",
                    [
                      _c("v-stepper-step", {
                        attrs: { dark: "", complete: _vm.e1 > 1, step: "1" }
                      }),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-stepper-step", {
                        attrs: { dark: "", complete: _vm.e1 > 2, step: "2" }
                      }),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-stepper-step", { attrs: { dark: "", step: "3" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-items",
                    [
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "1" } },
                        [
                          _c(
                            "form",
                            { staticClass: "form white--text" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "error-messages": _vm.nameErrors,
                                  counter: 20,
                                  label: "Name",
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.name.$touch()
                                  },
                                  blur: function($event) {
                                    _vm.$v.name.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  color: "#fff",
                                  "error-messages": _vm.emailErrors,
                                  label: "E-mail",
                                  required: ""
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "phone",
                                  value: "XXX-XXX-XXXX",
                                  "prepend-icon": "phone",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.e1 = 2
                                }
                              }
                            },
                            [_vm._v("\n          Next\n        ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "2" } },
                        [
                          _c(
                            "form",
                            { staticClass: "form white--text" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "error-messages": _vm.nameErrors,
                                  counter: 20,
                                  label: "College Association: ",
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.name.$touch()
                                  },
                                  blur: function($event) {
                                    _vm.$v.name.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.collegeAssociation,
                                  callback: function($$v) {
                                    _vm.collegeAssociation = $$v
                                  },
                                  expression: "collegeAssociation"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  "error-messages": _vm.emailErrors,
                                  label:
                                    "How Many Art Students Are In Your Program:",
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    _vm.$v.email.$touch()
                                  },
                                  blur: function($event) {
                                    _vm.$v.email.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.numberOfStudents,
                                  callback: function($$v) {
                                    _vm.numberOfStudents = $$v
                                  },
                                  expression: "numberOfStudents"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.submit }
                            },
                            [_vm._v("\n          Submit\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.e1 = 1
                                }
                              }
                            },
                            [_vm._v("Previous")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-stepper-content",
                        { attrs: { step: "3" } },
                        [
                          _c("v-flex", { attrs: { lg12: "" } }, [
                            _vm._v(
                              "\n             Thank You! We will be reaching out to you shortly. \n        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.e1 = 1
                                }
                              }
                            },
                            [_vm._v("\n          Start Again\n        ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb22b174", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb22b174","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/colleges.vue
// module id = null
// module chunks = 